<template>
  <div class="defaultPage">
    <div class="header">
      <img src="../../../assets/coursePage/common/Header/logo@3x.png" alt />
    
    </div>
    <div class="errorImg">
      <img src="../../../assets/coursePage/common/404.png" alt />
      <p>正在建设中~</p>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.defaultPage {
  width: 100%;
  .header {
    display: flex;
    align-items: center;
    width: 100%;
    height: 88px;
    box-shadow: 0 0 7px 3px rgba(0,0,0,.05);
    img {
      margin-left: 28px;
      width: 160px;
      height: 56px;
    }
  }
  .errorImg {
    width: 260px;
    overflow: hidden;
    position: absolute;
    top: 30%;
    left: 50%;
    transform: translate(-50%);
    -webkit-transform: translate(-50%);
    img {
      width: 100%;
      height: 100%;
    }
    p{
      font-family: PingFangSC, PingFang SC;
font-weight: 400;
font-size: 28px;
color: #86909C;
line-height: 44px;
text-align: center;
font-style: normal;
margin-top: 24px;
    }
  }
}
</style>